import Product, {
  getServerSideProps as _getServerSideProps
} from '#src/products/product-details-page'
import withSSRLoggingContext from '#lib/with-ssr-logging-context'
import withCommonPageProps from '#lib/with-common-page-props'
import pipe from 'ramda/src/pipe'

export const getServerSideProps = pipe(
  withSSRLoggingContext,
  withCommonPageProps({ path: '/products' })
)(_getServerSideProps)

export default Product
